<template>
  <div class="main-header-bg">
    <b-navbar toggleable="lg" class="bg-white" fixed="top">
      <b-container>
        <b-navbar-brand href="#/"
          ><img src="@/assets/logo.png" class="logo"
        /></b-navbar-brand>
        <div class="navbar">
          <div
            class="d-flex align-items-center nav-item"
            :class="{ active: activeId == 'index' }"
            @click="handleScroll('index')"
          >
            {{ $t("header.nav") }}
          </div>
          <div
            class="d-flex align-items-center nav-item"
            :class="{ active: activeId == 'product' }"
          >
            <span> {{ $t("header.nav2") }} </span>
            <div class="dropdown">
              <div class="dropdown_item" @click="handleCommand('acq')">
                <svgIcon className="icon" iconName="icon-h-acq"></svgIcon>
                <svgIcon className="icon-a" iconName="icon-h-acq-a"></svgIcon>
                {{ $t("header.nav2_1") }}
              </div>
              <div class="dropdown_item" @click="handleCommand('account')">
                <svgIcon className="icon" iconName="icon-h-acc"></svgIcon>
                <svgIcon className="icon-a" iconName="icon-h-acc-a"></svgIcon>
                {{ $t("header.nav2_2") }}
              </div>
              <div class="dropdown_item" @click="handleCommand('payment')">
                <svgIcon className="icon" iconName="icon-h-pay"></svgIcon>
                <svgIcon className="icon-a" iconName="icon-h-pay-a"></svgIcon>
                {{ $t("header.nav2_3") }}
              </div>
            </div>
          </div>
          <div
            class="d-flex align-items-center nav-item"
            :class="{ active: activeId == 'technology' }"
          >
            <span> {{ $t("header.nav3") }} </span>
            <div class="dropdown">
              <div class="dropdown_item" @click="handleCommand('system')">
                <svgIcon className="icon" iconName="icon-h-sys"></svgIcon>
                <svgIcon className="icon-a" iconName="icon-h-sys-a"></svgIcon>
                {{ $t("header.nav3_1") }}
              </div>
              <div class="dropdown_item" @click="handleCommand('tool')">
                <svgIcon className="icon" iconName="icon-h-tool"></svgIcon>
                <svgIcon className="icon-a" iconName="icon-h-tool-a"></svgIcon>
                {{ $t("header.nav3_2") }}
              </div>
            </div>
          </div>
          <div
            class="d-flex align-items-center nav-item"
            :class="{ active: activeId == 'develop' }"
          >
            <span>{{ $t("header.nav4") }}</span>
            <div class="dropdown">
              <div class="dropdown_item" @click="handleCommand('develop')">
                <svgIcon className="icon" iconName="icon-h-api"></svgIcon>
                <svgIcon className="icon-a" iconName="icon-h-api-a"></svgIcon>
                {{ $t("header.nav4_1") }}
              </div>
            </div>
          </div>
          <div
            class="d-flex align-items-center nav-item"
            :class="{ active: activeId == 'about' }"
          >
            <span>{{ $t("header.nav5") }}</span>
            <div class="dropdown">
              <div class="dropdown_item" @click="handleCommand('about')">
                <svgIcon className="icon" iconName="icon-h-about"></svgIcon>
                <svgIcon className="icon-a" iconName="icon-h-about-a"></svgIcon>
                {{ $t("header.nav5_1") }}
              </div>
              <div class="dropdown_item" @click="handleCommand('contact-us')">
                <svgIcon className="icon" iconName="icon-h-us"></svgIcon>
                <svgIcon className="icon-a" iconName="icon-h-us-a"></svgIcon>
                {{ $t("header.nav5_2") }}
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="btn1" @click="openLogin">
          <span>{{ $t("header.login") }}</span>
        </div> -->
      </b-container>
      <div class="radio_group">
        <el-radio-group v-model="locale" @change="handleLanguageChange">
          <el-radio-button label="zh">中文</el-radio-button>
          <el-radio-button label="en">English</el-radio-button>
        </el-radio-group>
      </div>
    </b-navbar>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeId: "home",
      routeName: "",
      locale: this.$i18n.locale
    };
  },
  watch: {
    $route: {
      immediate: true, // 如果需要在组件创建时立即触发，设置为true
      handler(newVal, oldVal) {
        // 当路由参数变化时，这里会被调用
        // newVal 是新的参数，oldVal 是旧的参数
        console.log("Route parameter changed:", newVal);

        // 你可以在这里根据新的参数执行相应的操作
        switch (newVal.name) {
          case "acq":
            this.activeId = "product";
            break;
          case "account":
            this.activeId = "product";
            break;
          case "payment":
            this.activeId = "product";
            break;
          case "system":
            this.activeId = "technology";
            break;
          case "tool":
            this.activeId = "technology";
            break;
          case "contact-us":
            this.activeId = "about";
            break;
          default:
            this.activeId = newVal.name;
            break;
        }
        this.routeName = newVal.name;
        this.$nextTick(() => {
          // 使用window.scrollTo或者window.scrollToTop方法滚动到顶部
          window.scrollTo(0, 0);
        });
      }
    }
  },
  mounted() {},
  methods: {
    handleLanguageChange(lang) {
      this.$i18n.locale = lang;
      localStorage.setItem("lang", lang);

      // // 同步 Element 组件语言
      // this.$nextTick(() => {
      //   this.$ELEMENT.locale =
      //     lang === "zh-CN"
      //       ? require("element-ui/lib/locale/lang/zh-CN")
      //       : require("element-ui/lib/locale/lang/en");
      // });
    },
    handleScroll(domId) {
      if (this.routeName == domId) return;
      switch (domId) {
        case "index":
          this.$router.push("/");
          break;
        case "develop":
          const url =
            "https://documenter.getpostman.com/view/32291077/2sA3sAi7rD";
          window.open(url);
          break;
        default:
          this.$router.push(`/${domId}`);
          break;
      }
    },
    handleCommand(command) {
      this.handleScroll(command);
    },
    openLogin() {
      this.$router.push("/login");
      // const url = "https://dashboard.zantechglobal.com/";
      // window.open(url);
    }
  }
};
</script>

<style lang="less" scoped>
.logo {
  width: auto;
  height: 70px;
}
.main-header-bg {
  position: relative;
  width: 100%;
  .navbar {
    display: flex;
    align-items: center;
    width: 100%;
    height: 80px;
  }
  .nav-item {
    position: relative;
    text-decoration: none;
    font-size: 20px;
    font-weight: 400;
    color: #242424;
    cursor: pointer;
    width: 20%;
    height: 100%;
    justify-content: center;
    &.active {
      &::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translate(-50%, -50%);
        background: #ea1a00; /* 修改为需要的颜色和宽度 */
        width: 72px;
        height: 5px; /* 修改为需要的高度 */
        border-radius: 2.5px;
      }
    }
    .dropdown {
      position: absolute;
      top: 65px;
      left: 50%;
      display: none;
      margin-left: -74px;
      padding: 10px 20px;
      // width: 148px;
      background: #ffffff;
      box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.44);
      border-radius: 10px 10px 10px 10px;
      z-index: 1;
      white-space: nowrap;
      .dropdown_item {
        margin: 12px 0;
        display: flex;
        align-items: center;
        font-weight: 400;
        font-size: 18px;
        color: #9e9e9e;
        .icon {
          margin-right: 12px;
          font-size: 30px;
        }
        .icon-a {
          display: none;
          margin-right: 12px;
          font-size: 30px;
        }
        &:hover {
          color: #db0d00;
          font-weight: 700;
          .icon {
            display: none;
          }
          .icon-a {
            display: inline-block;
          }
        }
      }
    }
    &:hover {
      .dropdown {
        display: block;
      }
    }
  }

  .btn1 {
    width: 120px;
    height: 40px;
    background: #1485ef;
    line-height: 40px;
    border-radius: 20px;
    text-align: center;
    font-weight: 400;
    font-size: 16px;
    color: #ffffff;
    cursor: pointer;
  }
}
.radio_group {
  position: absolute;
  top: 25px;
  right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue